<script setup lang="ts">
// A small, consistent "Saving… / ✓ Saved HH:MM" indicator. Pass a timestamp
// (Date.now()) whenever a save succeeds, and `saving` while one is in flight.
defineProps<{ savedAt: number | null; saving?: boolean }>();

function fmt(ts: number): string {
  return new Date(ts).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}
</script>

<template>
  <span
    v-if="saving"
    class="inline-flex items-center gap-1.5 text-xs text-neutral-400"
  >
    <span class="h-1.5 w-1.5 animate-pulse rounded-full bg-neutral-400" />
    Saving…
  </span>
  <span
    v-else-if="savedAt"
    class="inline-flex items-center gap-1 text-xs font-medium text-semantic-success"
  >
    ✓ Saved {{ fmt(savedAt) }}
  </span>
</template>
